/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HousingSiteResultType {
    NO_OFFER = 'NoOffer',
    QUALIFIED = 'Qualified',
    PREFERRED = 'Preferred',
    IN_INTAKE_FOR = 'InIntakeFor',
    REJECTED = 'Rejected',
}
